import { wrapPageTitle } from '@/renderer/getPageTitle';
import { captureAttribution } from '@/renderer/utils/stat/attribution';
import { initMixpanel } from '@/renderer/utils/stat/mixp';

export default function onAfterRenderClient(_pageContext: Vike.PageContext) {
  initMixpanel(); // this will process the queue up to now

  // Persist campaign attribution (utm_*/twclid) on a campaigned landing so it's
  // available to attach to any later order. No-op on plain in-app navigation.
  captureAttribution();

  // Brand the tab title app-wide (client half of the suffix; SSR half lives in
  // +onAfterRenderHtml.ts). On client navigation vike-react has already set
  // document.title to the page's resolved title by now, so re-wrapping it here
  // appends ` · RAS Picks`. On hydration the SSR title is already branded, and
  // wrapPageTitle skips anything containing "RAS", so this stays idempotent.
  if (typeof document !== 'undefined') {
    document.title = wrapPageTitle(document.title);
  }

  //   MixpanelProxy.track_pageview();
}
